__webpack_require__.p = "https://smartboard-frontend-4y7ib.ondigitalocean.app/";